@if (destinations) {
<div class="full-width main-picture">
  <div class="title">
    <h1>Destinations</h1>
  </div>
  <div class="cover-wrapper">
    <img
      id="timg"
      alt="destination-cover"
      class="full-width"
      ngSrc="/destinations/destinations.jpg"
      priority
      fill
    />
  </div>
  <div class="separator">
    <span></span>
  </div>
</div>
<div class="container destinations">
  <div class="w-10 container m-auto">
    @for (continent of continents; track $index) { @if(continentDestinations[continent].length > 0)
    {
    <div class="destination-container">
      <div class="continent">Destinations en {{ continent }}</div>
      @for (destination of continentDestinations[continent]; let i = $index; track $index) {
      <section
        class="destination-line"
        [class.disabled]="deviceService.isMobileOrTablet()"
        [@destinationAnimation]="hoverDestinations[destination.id] ? 'onHover' : 'onHide'"
        (mouseenter)="hoverDestination(destination.id, true)"
        (mouseleave)="hoverDestination(destination.id, false)"
        (click)="navigateToDestination(destination.country)"
      >
        <div class="destination-name">{{ destination.country }}</div>
        <div class="number">{{ i + 1 | number : '2.0-0' }}</div>
        <div
          class="image-container"
          [@destinationImageAnimation]="hoverDestinations[destination.id] ? 'onHover' : 'onHide'"
        >
          <img loading="lazy" [ngSrc]="destination.coverPicture.src" alt="destination" fill />
        </div>
      </section>
      }
    </div>
    } }
  </div>
</div>
<div class="full-width articles-container">
  @if (lastArticles) {
  <div class="container m-auto articles">
    <div class="row title-link full-width">
      <h2 class="w-10">Nos derniers articles</h2>
      @if (!deviceService.isMobile()) {
      <div class="w-2 link">
        <img
          loading="lazy"
          class="icon"
          alt="plus"
          ngSrc="/icons/plus.svg"
          width="12"
          height="12"
        />
        <a href="/articles">
          <ng-container>Tous nos articles</ng-container>
          <div class="line"></div>
        </a>
      </div>
      }
    </div>
    <div class="row full-width">
      <app-article-card
        *ngFor="let article of lastArticles | async"
        class="w-4"
        [class.w-6]="deviceService.isTablet()"
        [class.w-12]="deviceService.isMobile()"
        [article]="article"
        [showDescription]="false"
      >
      </app-article-card>
    </div>
    <div class="container">
      @if(deviceService.isMobile()){
      <div class="link">
        <img
          loading="lazy"
          class="icon"
          alt="plus"
          ngSrc="/icons/plus.svg"
          width="12"
          height="12"
        />
        <a href="/articles">
          <ng-container>Tous nos articles</ng-container>
          <div class="line"></div>
        </a>
      </div>
      }
    </div>
  </div>
  }
</div>
}
